import { render, staticRenderFns } from "./PageTranslator.vue?vue&type=template&id=40d0876a&scoped=true&"
import script from "./PageTranslator.vue?vue&type=script&lang=js&"
export * from "./PageTranslator.vue?vue&type=script&lang=js&"
import style0 from "./PageTranslator.vue?vue&type=style&index=0&id=40d0876a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d0876a",
  null
  
)

export default component.exports